import { createFileRoute } from "@tanstack/react-router"
import { LuRefreshCw } from "react-icons/lu"
import { Button } from "~/components/ui/button"

export const Route = createFileRoute("/offline")({
  component: OfflinePage,
})

function OfflinePage() {
  return (
    <div className="flex flex-col items-center justify-center h-dvh text-center px-m gap-m">
      <h1 className="text-2xl font-bold">Нет подключения к интернету</h1>
      <p className="text-muted-foreground">Проверьте соединение и попробуйте снова</p>
      <Button size="lg" onClick={() => location.reload()}>
        <LuRefreshCw />
        Обновить
      </Button>

      <script dangerouslySetInnerHTML={{ __html: "window.addEventListener('online', () => location.reload())" }} />
    </div>
  )
}
